export enum ARCHIVED_STATUS {
  ALL = 'all',
  ARCHIVED = 'archived',
  ACTIVE = 'active',
}
